<!-- eslint-disable max-len -->
<template>
  <div class="reviews">
    <div class="container-lg">
      <h2 class="reviews__title">
        Оценка пользователей — 5&nbsp;⭐
      </h2>
      <p class="reviews__subtitle">
        Больше отзывов на
        <a
          href="https://yandex.ru/maps/org/magvi/176658118910/reviews/?ll=99.505405%2C55.806974&utm_campaign=v1&utm_medium=rating&utm_source=badge&z=3"
          target="_blank"
        >
          Яндекс Картах
        </a>
      </p>
      <div class="reviews__list">
        <div class="reviews__review">
          <NuxtImg
            src="/home/reviews/review-1.webp"
            alt="Отзыв от Анастасии К. о Магви"
            sizes="460px 767px:946px 991px:574px 1199px:704px 1399px:884px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="1472"
            height="738"
            style="height: auto; aspect-ratio: 1472 / 738;"
          />
        </div>
        <div class="reviews__review">
          <NuxtImg
            src="/home/reviews/review-3.webp"
            alt="Отзыв от sergey.ms о Магви"
            sizes="460px 991px:333px 1199px:384px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="712"
            height="356"
            style="height: auto; aspect-ratio: 712 / 356;"
          />
        </div>
        <div class="reviews__review">
          <NuxtImg
            src="/home/reviews/review-2.webp"
            alt="Отзыв от Хабиб Р. о Magvi"
            sizes="460px 991px:333px 1199px:384px"
            fetchpriority="low"
            loading="lazy"
            densities="x1 x2"
            width="712"
            height="356"
            style="height: auto; aspect-ratio: 712 / 356;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.reviews {
  padding: rem(70px) 0;

  @include media-breakpoint-down(lg) {
    padding: rem(60px) 0;
  }

  &__title {
    font-size: rem(28px);
    line-height: 120%;
    margin-bottom: rem(8px);

    @include media-breakpoint-up(md) {
      font-size: rem(40px);
    }
    
    @include media-breakpoint-up(lg) {
      text-align: center;
    }
  }

  &__subtitle {
    margin-bottom: rem(20px);
    
    @include media-breakpoint-up(md) {
      margin-bottom: rem(32px);
    }
    
    @include media-breakpoint-up(lg) {
      text-align: center;
    }
  }

  &__list {
    display: grid;
    grid-template:
      "a1" minmax(148px, auto)
      "a2" minmax(148px, auto)
      "a3" minmax(148px, auto);
    gap: rem(8px);

    @include media-breakpoint-up(md) {
      grid-template: 
        "a1 a1" minmax(181px, auto)
        "a2 a3" minmax(181px, auto);
      gap: rem(24px);
    }

    @include media-breakpoint-up(lg) {
      grid-template: 
      "a1 a1 a2" minmax(154px, auto)
      "a1 a1 a3" minmax(154px, auto) / 1fr clamp(306px, 28vw, 386px) clamp(306px, 28vw, 386px);
      gap: rem(12px) rem(24px);
    }
  }

  &__review {
    display: flex;
    align-items: center;
    border-radius: rem(8px);
    border: 1px solid $gray-300;
    width: 100%;

    &:first-child {
      grid-area: a1;
    }

    &:nth-child(2) {
      grid-area: a2;
    }

    &:last-child {
      grid-area: a3;
    }

    img {
      border-radius: rem(8px);
      width: 100%;
    }
  }
}
</style>
